import { useObserver } from "mobx-react-lite";
import alarmsStore from "../../../../../stores/alarms.store";
import styled from "styled-components";

const Styles = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 10px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const CounterCardStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 14px 10px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(72, 77, 91, 0.5);
  border-top: 3px solid ${props => props.accentColor};
  border-radius: 6px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: ${props => props.accentColor};
    transform: translateY(-2px);
  }

  .label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: rgba(255, 255, 255, 0.52);
    margin-bottom: 6px;
  }

  .value {
    font-size: 24px;
    font-weight: 700;
    color: ${props => props.accentColor};
  }
`;

const AlarmsCountWrapperWidget = () => {
    return useObserver(() => (
        <AlarmsCountWidget
            ctit={ alarmsStore.criticalAlarmsCount }
            war={ alarmsStore.warningAlarmsCount }
            info={ alarmsStore.infoAlarmsCount }
        />
    ));
};

export default AlarmsCountWrapperWidget;

const AlarmsCountWidget = ({ ctit, war, info }) => {
    return (
        <Styles>
            <CounterCardStyled accentColor="#F86B63">
                <span className="label">Critical</span>
                <span className="value">{ ctit }</span>
            </CounterCardStyled>
            <CounterCardStyled accentColor="#F9BE49">
                <span className="label">Warning</span>
                <span className="value">{ war }</span>
            </CounterCardStyled>
            <CounterCardStyled accentColor="#36A2EF">
                <span className="label">Info</span>
                <span className="value">{ info }</span>
            </CounterCardStyled>
        </Styles>
    );
};